import type {
  BasketWithOptions,
  ProductWith,
  SearchV2With,
  WishlistWithOptions,
} from '@scayle/storefront-nuxt'
import type { RuntimeConfig } from 'nuxt/schema'

export const PRODUCT_DETAIL_WITH_PARAMS = {
  attributes: {
    withKey: [
      'features',
      'category',
      'manufacturerColor',
      'gender',
      'genders',
      'phasesOfLife',
      'productType',
      'articleNo',
      'articleNoSearch',
      'productCode',
      'manufacturerCode',
      'innerMaterial',
      'outerMaterial',
      'outsole',
      'innerSole',
      'material',
      'brand',
      'name',
      'color',
      'promotion',
      'onlineExclusiveFilter',
      'isExclusive',
      'affiliateRevenueModel',
      'isHotRelease',
      'accessoryType',
      'shoeType',
      'apparelType',
    ],
  },
  advancedAttributes: {
    withKey: ['description', 'brand_address'],
  },
  variants: {
    attributes: 'all',
    lowestPriorPrice: true,
    stock: true,
  },
  images: {
    attributes: {
      withKey: ['primaryImage'],
    },
  },
  categories: 'all',
  siblings: {
    images: {
      attributes: {
        withKey: ['primaryImage'],
      },
    },
    attributes: {
      withKey: [
        'color',
        'name',
        'brand',
        'genders',
        'phasesOfLife',
        'onlineExclusiveFilter',
        'isExclusive',
        'affiliateRevenueModel',
        'isHotRelease',
      ],
    },
    variants: {
      attributes: 'all',
      stock: true,
    },
    priceRange: true,
  },
  priceRange: true,
  lowestPriorPrice: true,
} satisfies ProductWith

export const PRODUCT_TILE_WITH_PARAMS = {
  attributes: {
    withKey: [
      'color',
      'category',
      'name',
      'brand',
      'genders',
      'phasesOfLife',
      'storefrontBadge',
      'promotion',
      'articleNoSearch',
      'productCode',
      'manufacturerCode',
      'onlineExclusiveFilter',
      'isExclusive',
      'affiliateRevenueModel',
      'isHotRelease',
      'accessoryType',
      'shoeType',
      'apparelType',
    ],
  },
  images: {
    attributes: {
      withKey: ['primaryImage'],
    },
  },
  categories: 'all',
  variants: {
    attributes: 'all',
    stock: true,
  },
  siblings: {
    images: {
      attributes: {
        withKey: ['primaryImage'],
      },
    },
    attributes: {
      withKey: [
        'color',
        'name',
        'brand',
        'genders',
        'phasesOfLife',
        'onlineExclusiveFilter',
        'isExclusive',
        'affiliateRevenueModel',
        'isHotRelease',
      ],
    },
    variants: {
      attributes: 'all',
      stock: true,
    },
    priceRange: true,
  },
  priceRange: true,
  lowestPriorPrice: true,
} satisfies ProductWith

export default {
  wishlist: {
    items: {
      variant: {
        attributes: {
          withKey: ['size'],
        },
        lowestPriorPrice: true,
        stock: true,
      },
      product: PRODUCT_TILE_WITH_PARAMS,
    },
  } satisfies WishlistWithOptions,
  basket: {
    items: {
      product: PRODUCT_DETAIL_WITH_PARAMS,
      variant: PRODUCT_DETAIL_WITH_PARAMS.variants,
      promotion: true,
    },
    applicablePromotions: true,
  } satisfies BasketWithOptions,
  product: PRODUCT_DETAIL_WITH_PARAMS,
  searchV2: {
    product: PRODUCT_TILE_WITH_PARAMS,
    categories: {
      parents: 'all',
      children: 0,
    },
    navigationItem: {
      category: 'all',
    },
  } satisfies SearchV2With,
} satisfies RuntimeConfig['storefront']['withParams']
